
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"22","viewBox":"0 0 25 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.88227 5.54545H24L22.2436 13.1727C22.0463 14.0366 21.1654 14.6532 20.1527 14.6364H9.10227C8.04582 14.6442 7.14867 13.9654 7.01136 13.0545L5.42227 2.58182C5.28597 1.67781 4.40077 1.00138 3.35227 1H1M8.31818 21C9.47296 21 10.4091 20.186 10.4091 19.1818C10.4091 18.1777 9.47296 17.3636 8.31818 17.3636C7.1634 17.3636 6.22727 18.1777 6.22727 19.1818C6.22727 20.186 7.1634 21 8.31818 21ZM20.8636 21C22.0184 21 22.9545 20.186 22.9545 19.1818C22.9545 18.1777 22.0184 17.3636 20.8636 17.3636C19.7089 17.3636 18.7727 18.1777 18.7727 19.1818C18.7727 20.186 19.7089 21 20.8636 21Z","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    